import { MARQUEE_WORDS } from "@/content";

const Diamond = () => (
  <svg viewBox="0 0 10 10" className="w-2.5 h-2.5 fill-cream/70 shrink-0">
    <rect x="1.5" y="1.5" width="7" height="7" transform="rotate(45 5 5)" />
  </svg>
);

export default function Marquee() {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div
      data-testid="marquee-strip"
      className="relative overflow-hidden bg-terracotta py-4 -rotate-1 scale-[1.02] my-2"
    >
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {[...row, ...row].map((word, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-cream text-xl sm:text-2xl whitespace-nowrap">
              {word}
            </span>
            <Diamond />
          </span>
        ))}
      </div>
    </div>
  );
}
